<template>
  <div>
    <table class="table table-sm table-list m-0 table-mobile">
      <thead>
        <tr>
          <th colspan="5">Drzwi</th>
        </tr>
        <tr>
          <th class="text-center">Ilość drzwi</th>
          <th class="text-center">Nowe</th>
          <th class="text-center">Do lakierowania</th>
          <th class="text-center">W starym budownictwie</th>
          <th class="text-center">Klamka G1700</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="isNotSubcontractor">
          <td data-label="Ilość drzwi">
            <b-form-input
              v-model="inputItems.doors"
              type="number"
              step="1"
              placeholder="0"
              class="text-center"
              @change="saveItems"
              min="0"
            ></b-form-input>
          </td>
          <td data-label="Nowe">
            <b-form-input
              v-model="inputItems.newdoors"
              type="number"
              step="1"
              placeholder="0"
              class="text-center"
              @change="saveItems"
              min="0"
            ></b-form-input>
          </td>
          <td data-label="Do lakierowania">
            <b-form-input
              v-model="inputItems.paintingdoors"
              type="number"
              step="1"
              placeholder="0"
              class="text-center"
              @change="saveItems"
              min="0"
            ></b-form-input>
          </td>
          <td data-label="W starym budownictwie">
            <b-form-input
              v-model="inputItems.doorsoldbuildings"
              type="number"
              step="1"
              placeholder="0"
              class="text-center"
              @change="saveItems"
              min="0"
            ></b-form-input>
          </td>
          <td data-label="Klamka G1700">
            <b-form-input
              v-model="inputItems.g1700handle"
              type="number"
              step="1"
              placeholder="0"
              class="text-center"
              @change="saveItems"
              min="0"
            ></b-form-input>
          </td>
        </tr>
        <tr v-else>
          <td class="text-center" data-label="Ilość drzwi">{{inputItems.doors}}</td>
          <td class="text-center" data-label="Nowe">{{inputItems.newdoors}}</td>
          <td class="text-center" data-label="Do lakierowania">{{inputItems.paintingdoors}}</td>
          <td class="text-center" data-label="W starym budownictwie">{{inputItems.doorsoldbuildings}}</td>
          <td class="text-center" data-label="Klamka G1700">{{inputItems.g1700handle}}</td>
        </tr>
      </tbody>
    </table>
    <table class="table table-sm table-list m-0 table-mobile">
      <thead>
        <tr>
          <th colspan="5">Okna</th>
        </tr>
        <tr>
          <th class="text-center">Ilość Okien</th>
          <th class="text-center">Fenster Plastik</th>
          <th class="text-center">Fenster Drewno</th>
          <th class="text-center">Parapet nowy</th>
          <th class="text-center">Parapet do lakierowania</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="isNotSubcontractor">
          <td data-label="Ilość Okien">
            <b-form-input
              v-model="inputItems.numberofwindows"
              type="number"
              step="1"
              placeholder="0"
              class="text-center"
              @change="saveItems"
              min="0"
            ></b-form-input>
          </td>
          <td data-label="Fenster Plastik">
            <b-form-input
              v-model="inputItems.windowplastic"
              type="number"
              step="1"
              placeholder="0"
              class="text-center"
              @change="saveItems"
              min="0"
            ></b-form-input>
          </td>
          <td data-label="Fenster Drewno">
            <b-form-input
              v-model="inputItems.windowwood"
              type="number"
              step="1"
              placeholder="0"
              class="text-center"
              @change="saveItems"
              min="0"
            ></b-form-input>
          </td>
          <td data-label="Parapet nowy">
            <b-form-input
              v-model="inputItems.newwindowsill"
              type="number"
              step="1"
              placeholder="0"
              class="text-center"
              @change="saveItems"
              min="0"
            ></b-form-input>
          </td>
          <td data-label="Parapet do lakierowania">
            <b-form-input
              v-model="inputItems.varnishsill"
              type="number"
              step="1"
              placeholder="0"
              class="text-center"
              @change="saveItems"
              min="0"
            ></b-form-input>
          </td>
        </tr>
        <tr v-else>
          <td class="text-center" data-label="Ilość Okien">{{inputItems.numberofwindows}}</td>
          <td class="text-center" data-label="Fenster Plastik">{{inputItems.windowplastic}}</td>
          <td class="text-center" data-label="Fenster Drewno">{{inputItems.windowwood}}</td>
          <td class="text-center" data-label="Parapet nowy">{{inputItems.newwindowsill}}</td>
          <td class="text-center" data-label="Parapet do lakierowania">{{inputItems.varnishsill}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "MeasurementItems",
  props: {
    items: {
      type: Object
    }
  },
  data() {
    return {
      timer: false,
      inputItems: {
        doors: 0,
        newdoors: 0,
        paintingdoors: 0,
        doorsoldbuildings: 0,
        g1700handle: 0,
        windowplastic: 0,
        windowwood: 0,
        newwindowsill: 0,
        varnishsill: 0,
        numberofwindows: 0
      }
    };
  },
  computed: {
    ...mapGetters("user", ["isNotSubcontractor"])
  },
  created() {
    this.$_.each(this.items, (item, key) => {
      this.inputItems[key] = item;
    });
  },
  methods: {
    ...mapActions("construction", ["measurementItems"]),
    saveItems() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        let newItems = JSON.parse(JSON.stringify(this.inputItems));
        this.measurementItems(newItems).then(() => {
          this.$store.commit("construction/measurementItems", newItems);
        });
      }, 500);
    }
  }
};
</script>
